function initProductShowcaseElement(section) {
  var thumbsEl = section.querySelector('.product-gallery-thumbs');
  var mainEl = section.querySelector('.product-gallery-main');

  if (!thumbsEl || !mainEl) return;

  if (typeof Swiper === 'undefined') {
    setTimeout(function() {
      initProductShowcaseElement(section);
    }, 100);
    return;
  }

  if (mainEl.swiper) {
    mainEl.swiper.destroy(true, true);
  }
  if (thumbsEl.swiper) {
    thumbsEl.swiper.destroy(true, true);
  }

  var slideCount = mainEl.querySelectorAll('.swiper-slide').length;
  var galleryWrapper = section.querySelector('.product-showcase-gallery');

  if (slideCount <= 1) {
    if (galleryWrapper) galleryWrapper.classList.add('is-single-slide');
    if (thumbsEl) thumbsEl.style.display = 'none';
    return;
  } else {
    if (galleryWrapper) galleryWrapper.classList.remove('is-single-slide');
    if (thumbsEl) thumbsEl.style.display = '';
  }

  var thumbsSwiper = new Swiper(thumbsEl, {
    spaceBetween: 12,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesProgress: true,
  });

  var mainSwiper = new Swiper(mainEl, {
    spaceBetween: 10,
    slidesPerView: 1,
    loop: false,
    thumbs: {
      swiper: thumbsSwiper,
    },
  });

  // Keep the active thumbnail and nearby thumbnails visible without centering
  // the active slide. This covers hover/click, dragging, and autoplay.
  var revealActiveThumbnail = function() {
    if (
      !mainSwiper ||
      mainSwiper.destroyed ||
      !thumbsSwiper ||
      thumbsSwiper.destroyed
    ) {
      return;
    }

    var activeIndex = mainSwiper.realIndex;
    var visibleCount = Math.floor(Number(thumbsSwiper.params.slidesPerView)) || 3;
    var maxStartIndex = Math.max(thumbsSwiper.slides.length - visibleCount, 0);
    var targetIndex = Math.min(
      Math.max(activeIndex - 1, 0),
      maxStartIndex
    );

    thumbsSwiper.slideTo(targetIndex, 300);
  };

  mainSwiper.on('slideChange', revealActiveThumbnail);
  revealActiveThumbnail();

  // Clean up previous listeners on mainEl to avoid duplicates or memory leaks
  if (mainEl._startAutoplay && mainEl._stopAutoplay) {
    mainEl.removeEventListener('mouseenter', mainEl._startAutoplay);
    mainEl.removeEventListener('mouseleave', mainEl._stopAutoplay);
    mainEl._stopAutoplay();
  }

  // Switch the main image whenever a desktop pointer hovers a thumbnail.
  // Event delegation keeps this working if Swiper rebuilds its slide elements.
  if (thumbsEl._thumbnailHoverListener) {
    thumbsEl.removeEventListener('pointerover', thumbsEl._thumbnailHoverListener);
  }

  var thumbnailHoverListener = function(event) {
    if (event.pointerType === 'touch') return;

    var slide = event.target.closest('.swiper-slide');
    if (!slide || !thumbsEl.contains(slide)) return;

    var previousSlide = event.relatedTarget && event.relatedTarget.closest
      ? event.relatedTarget.closest('.swiper-slide')
      : null;
    if (previousSlide === slide) return;

    var thumbSlides = Array.prototype.slice.call(
      thumbsEl.querySelectorAll('.swiper-slide')
    );
    var slideIndex = thumbSlides.indexOf(slide);

    if (slideIndex !== -1 && mainSwiper && !mainSwiper.destroyed) {
      mainSwiper.slideTo(slideIndex, 300);
    }
  };

  thumbsEl.addEventListener('pointerover', thumbnailHoverListener);
  thumbsEl._thumbnailHoverListener = thumbnailHoverListener;

  // Bind hover autoplay trigger to the main gallery preview
  var autoplayTimer = null;
  var showNextSlide = function() {
    if (!mainSwiper || mainSwiper.destroyed) return;

    if (mainSwiper.activeIndex >= mainSwiper.slides.length - 1) {
      mainSwiper.slideTo(0, 300);
    } else {
      mainSwiper.slideNext(300);
    }
  };
  var startAutoplay = function() {
    if (autoplayTimer) return;

    // Move immediately so hovering clearly reveals that this is a gallery.
    showNextSlide();
    autoplayTimer = setInterval(showNextSlide, 2000);
  };
  var stopAutoplay = function() {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  };

  mainEl.addEventListener('mouseenter', startAutoplay);
  mainEl.addEventListener('mouseleave', stopAutoplay);

  mainEl._startAutoplay = startAutoplay;
  mainEl._stopAutoplay = stopAutoplay;
}

window.updateProductShowcasePrice = function(select) {
  var option = select.options[select.selectedIndex];
  var price = option.getAttribute('data-price');
  var comparePrice = option.getAttribute('data-compare-price');
  var savings = option.getAttribute('data-savings');
  
  var buyBlock = select.closest('.product-buy-block');
  if (!buyBlock) return;
  
  var priceEl = buyBlock.querySelector('.product-price-current');
  var compareEl = buyBlock.querySelector('.product-price-compare');
  var savingsEl = buyBlock.querySelector('.product-savings-badge');
  
  if (priceEl && price) {
    priceEl.textContent = price;
  }
  
  if (compareEl) {
    if (comparePrice) {
      compareEl.textContent = comparePrice;
      compareEl.style.display = '';
    } else {
      compareEl.style.display = 'none';
    }
  }
  
  if (savingsEl) {
    if (savings) {
      savingsEl.textContent = savings;
      savingsEl.style.display = '';
    } else {
      savingsEl.style.display = 'none';
    }
  }

  var form = select.closest('form');
  if (form) {
    var variantInput = form.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.value = select.value;
    }
  }
};

function initAllProductShowcases() {
  document.querySelectorAll('.shopify-section--product-showcase').forEach(function(section) {
    initProductShowcaseElement(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllProductShowcases);
} else {
  initAllProductShowcases();
}

document.addEventListener('shopify:section:load', function(event) {
  if (event.target.classList.contains('shopify-section--product-showcase')) {
    initProductShowcaseElement(event.target);
  }
});
